export default "__VITE_ASSET__B_Hv9_p8__"